__turbopack_context__.v({
  "bgImg": "HeroBlock-module-scss-module__NBmXkG__bgImg",
  "bgImgWrapper": "HeroBlock-module-scss-module__NBmXkG__bgImgWrapper",
  "heroFullscreenVideo": "HeroBlock-module-scss-module__NBmXkG__heroFullscreenVideo",
  "moveDown": "HeroBlock-module-scss-module__NBmXkG__moveDown",
  "scrollDownDot": "HeroBlock-module-scss-module__NBmXkG__scrollDownDot",
  "scrollDownLottie": "HeroBlock-module-scss-module__NBmXkG__scrollDownLottie",
  "video": "HeroBlock-module-scss-module__NBmXkG__video",
  "wrapper": "HeroBlock-module-scss-module__NBmXkG__wrapper",
});
